import React from 'react';
import { useTranslations } from 'next-intl';
import { Link } from '@/navigation';
import btnIcons from '@/shared/assets/sprites/btns.sprite.svg';
import type { Skill } from '@/entities/skill/model/types';
interface Props {
  skills: Skill[];
  cityAlias: string;
  setLoadNewPage: (value: boolean) => void;
}
export const SkillsList: React.FC<Props> = ({
  skills,
  cityAlias,
  setLoadNewPage
}) => {
  const t = useTranslations('shared.header');
  return <section data-sentry-component="SkillsList" data-sentry-source-file="SkillsList.tsx">
      <p className="my-2 px-2 text-sm text-textSecondary">{t('searchResults.experts')}</p>

      <div className="flex flex-col gap-1">
        {skills.map(skill => <Link href={`/${cityAlias}/doctors/${skill.alias}`} key={skill.id} className="active:scale-97 group flex items-center justify-between rounded-lg px-2 py-3 transition-all duration-200 ease-in-out hover:bg-gray-50 hover:shadow-sm active:bg-gray-100" onClick={() => setLoadNewPage(true)}>
            <p className="text-sm text-black transition-colors duration-200 group-hover:text-primary">{skill.name}</p>

            <svg className="size-3.5 stroke-textPrimary stroke-1.5 transition-all duration-200 group-hover:translate-x-1 group-hover:stroke-primary">
              <use xlinkHref={`${btnIcons}#arrow`}></use>
            </svg>
          </Link>)}
      </div>
    </section>;
};